import { Navigate, Route, Routes } from 'react-router'
import { RequireSession } from './app/guards'
import { PortalShell } from './app/shell'
import { AnamnesisPage } from './features/anamneses/anamnesis-page'
import { AppointmentPage } from './features/appointments/appointment-page'
import { DocumentPage } from './features/documents/document-page'
import { HomePage } from './features/home/home-page'
import { RegisterPage } from './features/register/register-page'
import { SignPage } from './features/sign/sign-page'
import { SignInPage } from './features/sign-in/sign-in-page'
import { TreatmentPlanPage } from './features/treatment-plans/treatment-plan-page'
import { routes } from './routes'

/**
 * As rotas do portal do paciente (docs/areas/portal-do-paciente.md, T34): a entrada por código, o
 * cadastro pelo link da clínica (RN-POR-18), a assinatura pelo link (T38) e, com sessão, o início, o atendimento, o documento e a
 * ficha de saúde e o plano de tratamento encerrado (RN-POR-23). Só leitura (RN-POR-12).
 */
export function App() {
  return (
    <Routes>
      <Route path={routes.signIn} element={<SignInPage />} />
      <Route path={routes.register} element={<RegisterPage />} />
      <Route path={routes.sign} element={<SignPage />} />
      <Route element={<RequireSession />}>
        <Route element={<PortalShell />}>
          <Route path={routes.home} element={<HomePage />} />
          <Route path="/appointments/:id" element={<AppointmentPage />} />
          <Route path="/documents/:id" element={<DocumentPage />} />
          <Route path="/anamneses/:id" element={<AnamnesisPage />} />
          <Route path="/treatment-plans/:id" element={<TreatmentPlanPage />} />
          <Route path="*" element={<Navigate to={routes.home} replace />} />
        </Route>
      </Route>
    </Routes>
  )
}
